import BigNumber from 'bignumber.js'

export const safeMin = (...values: (string | number | BigNumber)[]) => {
  const nums = values.map((v) => new BigNumber(v)).filter((v) => v.isFinite()) // убираем NaN, Infinity, -Infinity

  return nums.length ? BigNumber.minimum(...nums) : new BigNumber(NaN)
}
